import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { File } from '@cl/shared/models/file.model';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ESignFlowSelectComponent } from './e-sign-flow-select/e-sign-flow-select.component';

@Component({
    selector: 'cl-e-sign',
    templateUrl: './e-sign.component.html',
    styleUrl: './e-sign.component.less',
    standalone: false,
})
export class ESignComponent implements AfterViewInit {
    @Input() disabled: boolean;
    @Input() files: File[];
    @Input() signableFileType: string;
    @Input() mergeMode: boolean = false;
    @Input() documentId: number;
    @Input() expenseId: number;

    constructor(private modalService: NzModalService) {}

    ngAfterViewInit(): void {
        if (!this.files) {
            throw Error('File or Files must be set!');
        }

        if (!this.signableFileType) {
            throw Error('SignableFileType must be set!');
        }
    }

    initializeESigning(): void {
        const modal = this.modalService.create({
            nzTitle: 'Autentifikācijas veida izvēle',
            nzContent: ESignFlowSelectComponent,
            nzWidth: 'fit-content',
            nzFooter: null,
        });

        modal.afterOpen.subscribe(() => {
            modal.getContentComponent().fileIds = this.files.map((file: File): number => {
                return file.id;
            });
            modal.getContentComponent().signableFileType = this.signableFileType;
            modal.getContentComponent().mergeMode = this.mergeMode;
            if (this.documentId) {
                modal.getContentComponent().documentId = this.documentId;
            }

            if (this.expenseId) {
                modal.getContentComponent().expenseId = this.expenseId;
            }
        });
    }
}
